"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.logOfferData = void 0;
var _logger = require("../logger");
var _types = require("../types");
const logOfferData = (param)=>{
    let { benefits, benefitsQuantity, items1stSection, items2ndSection, offerId, offerItems, offerType, purchases, requiredQuantity } = param;
    return (0, _logger.logDebug)("Current data for offer ".concat(offerId, ":"), '\n\tofferType:', "".concat(_types.basketOfferTypeNames[offerType], " (").concat(offerType, ")"), '\n\trequiredQuantity:', requiredQuantity, '\n\tbenefitsQuantity:', benefitsQuantity, '\n\tpurchases:', purchases, '\n\tbenefits:', benefits, '\n\tofferItems:', offerItems, '\n\titems1stSection:', items1stSection, '\n\titems2ndSection:', items2ndSection);
};
exports.logOfferData = logOfferData;
